import { FETCH_STORE_CREDIT_SUCCESS } from '../constants'

export default function storeCreditHistory(state = {}, action) {
    switch (action.type) {
        case FETCH_STORE_CREDIT_SUCCESS: {
            return { ...state, ...action.payload }
        }
        default:
            return state
    }
}
